import { render, staticRenderFns } from "./LogoutModal.vue?vue&type=template&id=4998e6e8&scoped=true"
import script from "./LogoutModal.vue?vue&type=script&lang=js"
export * from "./LogoutModal.vue?vue&type=script&lang=js"
import style0 from "./LogoutModal.vue?vue&type=style&index=0&id=4998e6e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4998e6e8",
  null
  
)

export default component.exports